import {
  Action,
  ActionTree,
} from 'vuex';

import {
  AuthAdaptor,
} from '@/adaptors/auth-adaptor';
import {
  SystemMessagesInstance,
} from '@/components/SystemMessages/instance';
import {
  SystemMessageType,
} from '@/enums/system-messages';
import {
  authTokenStorage,
  AuthTokenStorageValue,
} from '@/plugins/auth-token-storage';
import {
  i18n,
} from '@/plugins/vue-i18n';
import {
  AuthMutationsTypesEnum,
} from '@/store/modules/auth/mutation-types';
import {
  AuthState,
} from '@/store/modules/auth/types';
import {
  RootState,
} from '@/store/types';

type ModuleAction = Action<AuthState, RootState>;

const checkAuth: ModuleAction = ({ commit }): boolean => {
  const hasData = !!(authTokenStorage.value && Object.values(authTokenStorage.value).length);

  commit(AuthMutationsTypesEnum.UPDATE_AUTH_STATUS, hasData);

  return hasData;
};

const setCookies: ModuleAction = ({ commit }, data: AuthTokenStorageValue): void => {
  authTokenStorage.set(data);

  commit(AuthMutationsTypesEnum.UPDATE_AUTH_STATUS, !!authTokenStorage.value);
};

const refreshToken: ModuleAction = async ({ dispatch }): Promise<boolean> => {
  try {
    const { transformed } = await AuthAdaptor.refreshToken(authTokenStorage.refreshToken);

    if (transformed.data) {
      await dispatch('setCookies', {
        access_token: transformed.data.accessToken,
        refresh_token: transformed.data.refreshToken,
      });
    }

    return true;
  } catch (error) {
    SystemMessagesInstance.createMessage({
      type: SystemMessageType.error,
      showReloadButton: true,
      title: i18n.t('components.systemMessages.auth.authorization'),
      message: error.response ? error.response.data.reason : '',
    });

    return false;
  }
};

const logout: ModuleAction = ({ commit }): void => {
  authTokenStorage.clear();

  commit(AuthMutationsTypesEnum.UPDATE_AUTH_STATUS, false);
};

export const actions: ActionTree<AuthState, RootState> = {
  checkAuth,
  setCookies,
  refreshToken,
  logout,
};
